export default __webpack_public_path__ + "static/media/MathsPop.d6f221cb.png";